import * as Html2Canvas from 'html2canvas'
import JsPdf from 'jspdf'
export default {
    getPdf(arr, i, title, pdf) {
        var that = this;

        var options = {
            scale: 4,
            useCORS: true
        }

        var element = document.getElementById(arr[i]);
        var originalTexts = [];
        this.addSpacesToTextNodes(element, originalTexts, true);

        Html2Canvas(element, options).then(function (canvas) {

            console.log(window.devicePixelRatio)
            if (!pdf) {
                pdf = JsPdf('', 'pt', 'a4');
            }
            var contentWidth = canvas.width;
            var contentHeight = canvas.height;

            var pageHeight = contentWidth / 1160 * 1755;
            var leftHeight = contentHeight;


            var imgWidth = 595.28;
            var imgHeight = 595.28 / contentWidth * contentHeight;
            canvas.toBlob(function (blob) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var imgData = e.target.result;
                    if (i != 0) {
                        pdf.addPage();
                    }
                    pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);

                    i++;
                    if (i < arr.length) {
                        that.getPdf(arr, i, title, pdf)
                    }
                    if (i == arr.length) {
                        document.getElementById("loading").style.display = "none";
                        pdf.save(title);
                    }
                };
                reader.readAsDataURL(blob);
            }, 'image/jpeg', 1.0);

            that.addSpacesToTextNodes(element, originalTexts, false);
        })
    },
    addSpacesToTextNodes(element, texts, addSpace) {
        var childNodes = element.childNodes;
        for (var i = 0; i < childNodes.length; i++) {
            var node = childNodes[i];
            if (node.nodeType === Node.TEXT_NODE) {
                if (addSpace) {
                    texts.push(node.textContent);
                    node.textContent = node.textContent.replace(/([。！？，、；："'\)》】”’])([（《])/g, '$1\u2009$2');
                } else {
                    node.textContent = texts.shift();
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                this.addSpacesToTextNodes(node, texts, addSpace);
            }
        }
    }
}